import { render, staticRenderFns } from "./commission-statement-ordered.vue?vue&type=template&id=4f662b6b"
import script from "./commission-statement-ordered.vue?vue&type=script&lang=js"
export * from "./commission-statement-ordered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports